import { Injectable } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';
import { HeaderOverride } from './header-overrides.constants';
import { isEmpty, cloneDeep } from 'lodash-es';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { SsrService } from '../ssr/ssr.service';

const HEADER_OVERRIDES = 'header-overrides';
const LOGGER_MESSAGE = 'Header Overrides Service:';

@Injectable()
export class HeaderOverridesService {
    private headers: Array<HeaderOverride> = [];
    private defaultValue = { headers: [] };

    constructor(
        private logger: LoggerService,
        private ssrService: SsrService,
        private localStorageService: LocalStorageService
    ) { }

    /**
     * @name            getHeaders
     * @description     Retrieve all the header overrides
     * @returns         Array<HeaderOverride>
     */
    getHeaders(): Array<HeaderOverride> {
        if (this.ssrService.isSSR()) {
            return [];
        }

        let storageValue = this.localStorageService.get(HEADER_OVERRIDES);

        // Set some default values
        if (!storageValue) {
            storageValue = JSON.stringify(this.defaultValue);
            this.localStorageService.set(HEADER_OVERRIDES, storageValue);
        }

        // Pull the overrides out of storage
        try {
            if (typeof storageValue === 'string') {
                const results = JSON.parse(storageValue);
                this.headers = results.headers;
            } else {
                this.headers = storageValue.headers;
            }
        } catch (err) {
            this.logger.error(`${LOGGER_MESSAGE} could not parse header overrides. storageValue: ${JSON.parse(storageValue)}`);
        }

        return this.headers;
    }

    /**
     * @name            setHeaders
     * @description     Set new header overrides
     * @param newHeaders Array of HeaderOverride objects
     */
    setHeaders(newHeaders: Array<HeaderOverride>) {
        if (this.ssrService.isSSR()) {
            return;
        }

        const storageValue = cloneDeep(this.defaultValue);

        // Ignore values with empty headers or values
        this.headers = newHeaders.filter(header => !isEmpty(header.header) && !isEmpty(header.value));

        // Update the storage object
        storageValue.headers = this.headers;

        // Store the values
        this.localStorageService.set(HEADER_OVERRIDES, JSON.stringify(storageValue));
    }

}
